import { Navigate } from "react-router-dom";
import { useInvestorSession } from "../../../hooks/useInvestorSession";

/**
 * Cooperative “service request” is retired.
 * Join/become-a-member always uses the existing member registration path.
 * Existing members are sent to the member dashboard.
 */
export default function CooperativeRequestPage() {
  const { isMember, isRealInvestor } = useInvestorSession();

  if (isMember && !isRealInvestor) {
    return <Navigate to="/member/dashboard" replace />;
  }

  return <Navigate to="/member-signup" replace />;
}
